import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { STORE, STORE_MERGING_LOG } = API_URLS;

//Getting Paginated Survey Queues
const getMergeDuplicateStoresLogs = (body) => {
  return postRequest(STORE_MERGING_LOG.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const mergeDublicateStores = (oldStoreId, newStoreId) => {
  return postRequest(
    `${STORE.REPLACE_STORE}/${oldStoreId}/${newStoreId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const mergeDuplicateStoresServices = {
  mergeDublicateStores,
  getMergeDuplicateStoresLogs,
};
